import script from "./CRMWhatsappInvoicesView.vue?vue&type=script&setup=true&lang=js"
export * from "./CRMWhatsappInvoicesView.vue?vue&type=script&setup=true&lang=js"

import "./CRMWhatsappInvoicesView.vue?vue&type=style&index=0&id=9211ad6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9211ad6a"]])

export default __exports__